import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import MsxIcons from '../features/msx-icons';
import DropdownMenu from './dropdown_menu';
import I10n from '../features/i10n';
import { PRIMARY_COLOR, SECONDARY_COLOR } from '../color-constants';

const Container = styled.div`
  display: flex;
  word-break: break-word;
`;

const ChipWrapper = styled.div`
  min-height: 22px;
  font-size: 14px;
  line-height: 17px;
  display: inline-flex;
  margin: 4px;
  padding-left: 8px;
  padding-right: 8px;
  font-weight: 400;
  text-align: left;
  background: transparent;
  outline: none;
  border-radius: 16px;
  align-items: center;
  transition: all 0.2s ease 0s;
  ${props => {
    if (props.disabled) {
      return `
        cursor: default;
        background-color: inherit;
        color: rgb(203, 203, 203);
        border: 1px solid rgb(203, 203, 203);
       `;

    } else if (props.preSelected) {
      return `
        cursor: default;
        border: 1px solid  ${SECONDARY_COLOR};
        border: 1px solid var(--se-primary, ${SECONDARY_COLOR});
        color: ${SECONDARY_COLOR};
        color: var(--se-primary, ${SECONDARY_COLOR});
       `;

    } else if (props.selected) {
      return `
        cursor: pointer;
        color: white;

        background-color: ${SECONDARY_COLOR};
        background-color: var(--se-primary, ${SECONDARY_COLOR});
        border: 1px solid ${SECONDARY_COLOR};
        border: 1px solid var(--se-primary, ${SECONDARY_COLOR});
        color: white;
        color: var(--se-primary-contrast, white);
      `;

    } else {
      return `
        cursor: pointer;
        border: 1px solid rgb(67, 67, 67);
        color: rgb(51, 51, 51);
        :hover {
          background-color: #EDEDED;
        }
       `;
    }
  }}
`;

const WarningWrapper = styled.div`
  width: 200px;
  color: ${PRIMARY_COLOR};
  color: var(--se-secondary, ${PRIMARY_COLOR});
  position: relative;
  padding: 15px;
  font-size: 14px;
`;

const WarningIconWrapper = styled.div`
  position: absolute;
  top: 5px;
  right: 5px;
`;

const WarningMessage = styled.span``;

const ErrorMessage = styled.span`
  color: #dc0a0a;
  color: var(--se-error, #dc0a0a);
`;

const Label = styled.span``;


class Chip extends React.Component {

  static propTypes = {
    scrollbarWrapper: PropTypes.object,
    disabled: PropTypes.bool,
    title: PropTypes.string,
    value: PropTypes.string,
    selected: PropTypes.bool,
    loading: PropTypes.bool,
    preSelected: PropTypes.bool,
    showCheck: PropTypes.bool,
    showHint: PropTypes.bool,
    onClick: PropTypes.func,
    id: PropTypes.string
  }

  renderChip = () => {
    return (
      (this.props.showHint && (this.props.preSelected || (this.props.disabled && !this.props.loading))) ?
        <DropdownMenu
          data-clickable
          toggleElement={this.renderToggle()}
          containerElement={this.renderDropdownContent()}
          prioritizeTop={true}
          correctionWidthOffset={15}
          closeAfterDelay={5000}
          boundingElement={this.props.scrollbarWrapper}
        ></DropdownMenu> : this.renderToggle());
  }

  renderToggle = () => {
    const chipProps = {
      name: 'done',
    };
    return (<ChipWrapper disabled={this.props.disabled} preSelected={this.props.preSelected} selected={this.props.selected}>
      {(this.props.preSelected || this.props.selected) && this.props.showCheck ?
        <MsxIcons {...chipProps}></MsxIcons> : <></>}
      <Label>{this.props.value}</Label>
    </ChipWrapper>);
  }

  renderDropdownContent = () => {
    let warningMessage = I10n.get('filters.warning.preselected');
    let color = "secondary";
    let messageLabel = <WarningMessage>{warningMessage}</WarningMessage>
    if (this.props.disabled) {
      warningMessage = I10n.get('filters.warning.disabled');
      color = "error";
      messageLabel = <ErrorMessage>{warningMessage}</ErrorMessage>
    }
    return <WarningWrapper>
      <WarningMessage>
        {messageLabel}
      </WarningMessage>
      <WarningIconWrapper>
        <MsxIcons name="info_hover" color={color} size="nano"></MsxIcons>
      </WarningIconWrapper>
    </WarningWrapper>;
  }

  render = () => {
    const idProps = {};
    if (this.props.id) {
      idProps['id'] = this.props.id;
      if (this.props.disabled) {
        idProps['id'] += '-disabled';
      }
    }

    return (
      <Container {...idProps} onClick={(event) => {
        if (!this.props.disabled && !this.props.preSelected) {
          this.props.onClick(event);
        }
      }} title={this.props.title}>
        {this.renderChip()}
      </Container>
    );
  }
}

export default Chip;
